import type { Dependencies } from "@redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveExternalProviderBatchRequestList = createAsyncThunk<
  ExternalProviderBatchRequestVM[],
  void,
  { extra: Partial<Dependencies> }
>("externalProviderBatchRequests/adminRetrieveExternalProviderBatchRequestList", async (_: void, { extra: { adminRepository } }) => {
  return adminRepository!.listExternalProviderBatchRequests();
});
